import { reportsLeadChartListOptions } from '@crm/api'
import { getColor } from '@crm/components/Charts/utils'
import { DashboardProps } from '@crm/features/reports'
import { abbreviateNumber } from '@crm/utils'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Card, Empty } from 'antd'
import {
  Area,
  CartesianGrid,
  ComposedChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'

const color = getColor(4)

export const LeadApplicationsChart = ({ ...params }: DashboardProps) => {
  const { t } = useLocales()

  const { data = [], isLoading } = useQuery({
    ...reportsLeadChartListOptions({ query: { ...params } }),
    select: (response) => {
      if (response?.length) {
        return response?.map(({ value, date }) => ({
          value,
          date
        }))
      }
      return []
    }
  })

  return (
    <Card title={t('reports.evolution_lead_applications')} loading={isLoading}>
      {data?.length ? (
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart data={data}>
            <defs>
              <linearGradient id="colorLine3" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.8} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>

            <CartesianGrid vertical={false} strokeDasharray="4 0" />
            <XAxis dataKey="date" scale="band" />
            <YAxis
              yAxisId="left"
              orientation="left"
              scale="auto"
              type="number"
              tickFormatter={(value) => abbreviateNumber(value)}
            />
            <Tooltip
              content={({ active, payload }) =>
                active && payload
                  ? `${payload[0].payload.date} - ${abbreviateNumber(
                      payload[0].value as number
                    )}`
                  : null
              }
            />
            <Area
              type="monotone"
              yAxisId="left"
              dataKey="value"
              stroke={color}
              fillOpacity={1}
              fill="url(#colorLine3)"
              activeDot={{ stroke: color, strokeWidth: 4 }}
              dot={{ stroke: 'white', strokeWidth: 3, r: 6, fill: color }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      ) : (
        <Empty description={t('main.no_data')} />
      )}
    </Card>
  )
}
